package com.anjuros.website.redesign.sections.designs

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdEyebrow
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.RdGhostButtonOnDarkStyle
import com.anjuros.website.redesign.styles.RdGhostButtonStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdNextCardDarkStyle
import com.anjuros.website.redesign.styles.RdNextCardStyle
import com.anjuros.website.redesign.styles.RdNextGridStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/** Two closing options: start from a design, or go fully bespoke. */
@Composable
fun DesignsNextStepSection() {
    RdSection(id = "next", labelledBy = "next-h") {
        RdSectionHead(RdText.DESIGNS_NEXT_EYEBROW, "next-h", RdText.DESIGNS_NEXT_TITLE)
        Div(RdNextGridStyle.toModifier().toAttrs()) {
            NextCard(
                RdText.DESIGNS_NEXT1_EYEBROW, RdText.DESIGNS_NEXT1_TITLE, RdText.DESIGNS_NEXT1_TEXT,
                RdText.CTA_FREE_PREVIEW, dark = true
            )
            NextCard(
                RdText.DESIGNS_NEXT2_EYEBROW, RdText.DESIGNS_NEXT2_TITLE, RdText.DESIGNS_NEXT2_TEXT,
                RdText.DESIGNS_NEXT2_BUTTON
            )
        }
    }
}

@Composable
private fun NextCard(eyebrow: RdText, title: RdText, text: RdText, button: RdText, dark: Boolean = false) {
    Div(RdNextCardStyle.toModifier().thenIf(dark, RdNextCardDarkStyle.toModifier()).toAttrs()) {
        RdEyebrow(eyebrow)
        H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(title)) }
        P { Text(LocalText(text)) }
        RdGhostButton(
            RdRoute.CONTACT, button, withArrow = true,
            modifier = if (dark) RdGhostButtonOnDarkStyle.toModifier() else RdGhostButtonStyle.toModifier()
        )
    }
}
